import {getGemSettingsFeature} from 'app/utils/config/getGemSettingsFeature';
import {GemSettings} from 'app/utils/config/interface';
import {ComposedPageSettingsConfig} from 'interfaces/composedpages/configuration/composedPageSettingsConfig';

export async function initLoadCptSubPage(gemSettings: GemSettings) {
    const composedPageConfig = getGemSettingsFeature<ComposedPageSettingsConfig>(gemSettings, 'composed-page');
    if (gemSettings.wcmMode !== 'EDIT' && composedPageConfig?.individualPages && composedPageConfig.individualPages.length > 0) {
        const cptLoadSubPagesModule = await import(/* webpackChunkName: "loadCptSubPage" */ './index');
        await cptLoadSubPagesModule.loadCptSubPage(composedPageConfig, gemSettings);
    }
}
